import React from 'react'
import create from 'zustand'
import createContext from 'zustand/context'
import shallow from 'zustand/shallow'

const { Provider, useStore } = createContext()

const createStore = () =>
  create((set) => {
    const setEditableSlugs = (editableSlugs) => {
      set(() => ({ editableSlugs }))
    }

    const setEditableSlugFields = (editableSlugFields) => {
      set(() => ({ editableSlugFields }))
    }

    const setIsReCreate = (isReCreate) => {
      set(() => ({ isReCreate }))
    }

    const setRefreshLog = (refreshLog) => {
      set(() => ({ refreshLog }))
    }

    const setCurrentData = (currentData) => {
      set(() => ({ currentData }))
    }
    const setOriginalData = (originalData) => {
      set(() => ({ originalData }))
    }

    const reset = () => {
      set(() => ({
        currentData: null,
        originalData: null,
        isReCreate: false,
        refreshLog: false,
        editableSlugs: [],
      }))
    }

    return {
      currentData: null,
      originalData: null,
      isReCreate: false,
      refreshLog: false,
      editableSlugs: [],
      editableSlugFields: [],
      setEditableSlugs,
      setEditableSlugFields,
      setIsReCreate,
      setRefreshLog,
      setOriginalData,
      setCurrentData,
      reset,
    }
  })

const DetailStoreProvider = function ({ children }) {
  return <Provider createStore={createStore}>{children}</Provider>
}

const useDetailStore = (selectors, equalityFn = shallow) =>
  useStore(selectors, equalityFn)

export { DetailStoreProvider, useDetailStore }
